import countries from 'consts/countries'
import { DEFAULT_AUDIENCE } from 'consts/defaultAudience'

export default function getAudienceFromUrl(search: string) {
  const audienceKeys = Object.keys(DEFAULT_AUDIENCE)
  const currentUrlParams = new URLSearchParams(search)
  const audienceFilters = audienceKeys.reduce((prev, curr) => {
    if (curr === 'audienceAges') {
      const currentValue = currentUrlParams.getAll(curr)
      if (currentValue.length) {
        const valueAray = currentValue.map(item => ({ value: item }))
        return {
          ...prev,
          [curr]: valueAray,
        }
      }
      return {
        ...prev,
        [curr]: DEFAULT_AUDIENCE[curr],
      }
    }
    const currentValue = currentUrlParams.get(curr)
    if (curr === 'audienceCountries') {
      const countryLabel = countries.find(item => item.ALPHA_2 === currentValue)
      const countryObject = {
        value: currentValue,
        label: countryLabel?.NAME,
      }

      return {
        ...prev,
        [curr]: currentValue ? countryObject : DEFAULT_AUDIENCE[curr],
      }
    }
    return {
      ...prev,
      [curr]: currentValue ? { value: currentValue } : DEFAULT_AUDIENCE[curr],
    }
  }, {})

  return audienceFilters
}
